const FOLIB_BASE = 'https://public.bocloud.com.cn';

export const UPDATE_POLL_INTERVAL_MS = 12 * 60 * 60 * 1000;

type FolibArtifactResponse = {
  listTree?: { name?: string }[];
};

export interface AppUpdateInfo {
  latestVersion: string;
  url: string;
}

const toVersionParts = (version: string): number[] => (
  version
    .split('.')
    .map((part) => {
      const match = part.trim().match(/^\d+/);
      return match ? Number.parseInt(match[0], 10) : 0;
    })
);

/** 按数字段比较产品版本，返回负数、零或正数；复用于连接器最低版本校验。 */
export const compareVersions = (a: string, b: string): number => {
  const aParts = toVersionParts(a);
  const bParts = toVersionParts(b);
  const maxLength = Math.max(aParts.length, bParts.length);

  for (let i = 0; i < maxLength; i += 1) {
    const left = aParts[i] ?? 0;
    const right = bParts[i] ?? 0;
    if (left > right) return 1;
    if (left < right) return -1;
  }

  return 0;
};

const isNewerVersion = (latestVersion: string, currentVersion: string): boolean => (
  compareVersions(latestVersion, currentVersion) > 0
);

const getPackageName = (): string => {
  if (window.electron.platform === 'darwin') {
    return 'boclaw-macos-universal.zip';
  }
  return 'boclaw-windows-x64.zip';
};

const extractVersionFromFileName = (fileName: string): string | null => {
  const match = fileName.match(/(\d+\.\d+\.\d+)/);
  return match ? match[1] : null;
};

export const checkForAppUpdate = async (currentVersion: string): Promise<AppUpdateInfo | null> => {
  const packageName = getPackageName();
  const checkUrl = `${FOLIB_BASE}/api/browse/getArtifact/foagent/foagent-raw/boclaw/${packageName}?type=raw&digest=&report=false`;

  const response = await window.electron.api.fetch({
    url: checkUrl,
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok || typeof response.data !== 'object' || response.data === null) {
    return null;
  }

  const payload = response.data as FolibArtifactResponse;
  const firstItem = payload.listTree?.[0];
  if (!firstItem?.name) {
    return null;
  }

  const latestVersion = extractVersionFromFileName(firstItem.name);
  if (!latestVersion || !isNewerVersion(latestVersion, currentVersion)) {
    return null;
  }

  const downloadUrl = `${FOLIB_BASE}/storages/foagent/foagent-raw/boclaw/${packageName}`;
  return {
    latestVersion,
    url: downloadUrl,
  };
};
